import { UserProfile } from 'components/userProfile';

import { useConversationRow } from '../../../utils/useConversationRow';

import styles from './conversationsTableAssignedAgent.module.scss';

/** Represents the content of the assigned agent cell in the conversations table. */
export const ConversationsTableAssignedAgent = (): JSX.Element | null => {
  const { conversation, density } = useConversationRow();

  // TODO: Implement unassigned agent presentation
  return (
    <UserProfile
      user={conversation.assigned_to ?? undefined}
      unknownLabel="Unassigned"
      nameClassName={conversation.assigned_to ? undefined : styles.unassigned}
      truncateName={density === 'compact'}
    />
  );
};
